<template xmlns:v="http://www.w3.org/1999/html">
    <div class="shop">
        <div class="left">
            <h2>{{languageStrings['servicesHeadline']}}</h2>
            <p>{{languageStrings.servicesText}}</p>

            <div class="servicepoints-container">
                <h3>{{languageStrings['Servicepoints Anzeigen']}}</h3>
                <div class="servicePoints">
                    <div @click=" selectServicePoint('toilet')" :class="{ activeSP : selectedServicePoints == 'toilet' }">
                        <service-point  :type="'toilet'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('info')" :class="{ activeSP : selectedServicePoints == 'info' }">
                        <service-point  :type="'info'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('bank')" :class="{ activeSP : selectedServicePoints == 'bank' }">
                        <service-point :type="'bank'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('lock')" :class="{ activeSP : selectedServicePoints == 'lock' }">
                        <service-point :type="'lock'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('lift')" :class="{ activeSP : selectedServicePoints == 'lift' }">
                        <service-point :type="'lift'" :position="{x:0,y:0}"></service-point>
                    </div>
                    <div @click="selectServicePoint('parkdeck')" :class="{ activeSP : selectedServicePoints == 'parkdeck' }">
                        <service-point :type="'parkdeckmain'" :position="{x:0,y:0}"></service-point>
                    </div>
                </div>
            </div>

        </div>

        <div class="main">
            <div id="map">
                <HausNavigation></HausNavigation>
                <MapCanvas :startpoint="startLocation" :endpoint="false" :nodes="nodes"></MapCanvas>
                <MapStartIcon type="start" :top="getStartLocation.y" :left="getStartLocation.x"></MapStartIcon>
                <div class="service-points">
                    <ServicePoint :dataid="key" :type="point.type" :position="point.position" :fill="point.fill" v-for="(point, key) in activeServicePoints"></ServicePoint>
                </div>

            </div>
            <router-link v-if="backlink" :to="backlink" class="backlink button"><img alt="" src="@/assets/chevleft.svg"> {{languageStrings['Übersicht']}}</router-link>
            <div id="restart" class="newloadbutton" v-if="shop"><img src="@/assets/reloadicon.svg">{{languageStrings['Neu Laden']}} </div>
            <div class="error" v-if="hasError">Oops, something went wrong</div>
        </div>
    </div>


</template>

<script>
// @ is an alias to /src
import { gsap } from 'gsap';
import HausNavigation from '@/components/HouseNavigation.vue'
import MapStartIcon from '@/components/MapStartIcon.vue'
import MapCanvas from '@/components/MapCanvas.vue'
import ServicePoint from '@/components/ServicePoint.vue'
import { nodes, servicePoints, getActiveHouses, getDirectionHouses, navigate, startDescriptions, parseNode } from '@/nodes.js'

export default {
    name: 'Services',
    components: {MapStartIcon, HausNavigation, MapCanvas, ServicePoint},
    data() {
        return {
            backlink: this.$route.params.backlink,
            selectedServicePoints: false,
            hasError: false,
            getDirectionHouses: [],
            startLocation: false,
            activeHouses: false,
            routes: false,
            LangElementsDE: '#Hausbeschreibung > *, #Entrances > *',
            LangElementsEN: '#Hausbeschreibung-englisch > *, #Entrances-englisch > *'
        }
    },
    props: ['store', 'location', 'languageStrings', 'options', 'houseColors', 'currentLanguage'],
    created() {
        this.nodes = nodes;
        this.servicePoints = servicePoints;
        this.startDescriptions = startDescriptions;
        this.startLocation = this.options.location;
        this.routes = navigate(this.startLocation, this.endLocation)
        this.webStartSelect = this.startLocation

    },
    watch: {
        currentLanguage: function(newVal, oldVal){
            // this.startNavigationServicepoints()
            document.getElementById('parkdeck-englisch').style.opacity = 0
            document.getElementById('parkdeck').style.opacity = 0
            if (this.selectedServicePoints == 'parkdeck'){
                if (this.currentLanguage == 'en'){
                    document.getElementById('parkdeck-englisch').style.opacity = 1
                } else if ( this.currentLanguage == 'de'){
                    document.getElementById('parkdeck').style.opacity = 1
                }
            }
        }
    },
    computed: {

        activeLangElements(){
            if (this.currentLanguage == 'de'){
                return this.LangElementsDE
            } else if (this.currentLanguage == 'en' ){
                return this.LangElementsEN
            }
        },
        shop(){
            return false
        },
        navigationExtras(){
            if (this.location.level == 2 && this.shop.level == 1){
                return '#nothing';
                // return '#pont13, #point23, #esc23, #esc23 g';
            }
        },
        getStartLocation(){
            //retuns the startnode object
            let v = this;
            return this.nodes.find(x => x.id == v.startLocation)
        },
        activeServicePoints(){
            //filters the visible service icons
            let v = this;
            return this.servicePoints.filter(x=> x.type == v.selectedServicePoints)
        },
        startPointParsed(){
            return parseNode(this.startLocation)
        },
        canBeNavigated(){
            return false
        },
    },
    methods: {
        startNavigationServicepoints(){

            this.selectedServicePoints = this.$route.params.type

            if (this.selectedServicePoints == 'parkdeck'){
                if (this.currentLanguage == 'en'){
                    document.getElementById('parkdeck-englisch').style.opacity = 1
                } else if ( this.currentLanguage == 'de'){
                    document.getElementById('parkdeck').style.opacity = 1
                }
            }

            let starthouseid = 'haus' + this.startPointParsed.level + this.startPointParsed.house;
            let starthouse = document.getElementById(starthouseid);

            if (this.id === 'servicepoint'){
                this.selectedServicePoints = this.$route.params.type
            }

            gsap.set(this.LangElementsDE, {opacity: 0, scale: 0, transformOrigin: 'center'} )
            gsap.set(this.LangElementsEN, {opacity: 0, scale: 0, transformOrigin: 'center'} )
            gsap.set(this.activeLangElements, {opacity: 1, scale: 1, transformOrigin: 'center'} )

        },
        selectServicePoint(type){
            document.getElementById('parkdeck-englisch').style.opacity = 0
            document.getElementById('parkdeck').style.opacity = 0

            if (type != this.selectedServicePoints ){
                this.selectedServicePoints = type;
                if (type == 'parkdeck'){
                    if (this.currentLanguage == 'en'){
                        document.getElementById('parkdeck-englisch').style.opacity = 1
                    } else if ( this.currentLanguage == 'de'){
                        document.getElementById('parkdeck').style.opacity = 1
                    }
                }

            } else {
                this.selectedServicePoints = false;
            }
        },
    },
    mounted() {

        this.startNavigationServicepoints()
    }
}

</script>

<style></style>

<style lang="scss" scoped>
@import "../../styles/variables";

h2 {
    color: $gray2;
    margin-bottom: 110px;
}

h3 {
    color: $gray2;
    font-size: 24px;
}

p {
    color: $gray2;
    font-size: 24px;
    margin-bottom: 80px;
}


.shop {
    width: 100%;
}


.main {
    padding-top: 0 !important;
    padding-right: 40px !important;
    img.preview {
        width: 100%;
    }
}

$servicepointsPortraitWidth: 38%;

.left {
    width: 35%;
    background: #F6F5F2;
    height: 100%;
    padding: 90px 108px;
    position: relative;

    @include portrait(){
        width: 100%;
        order: 12;
        transform: scale(1.4);
        transform-origin: left top;
        padding: 30px 38px;
        padding-right: $servicepointsPortraitWidth - 5%;
        width: 771px;
        height: 620px;
        bottom: 0px;
    }
}

h2 {
    @include portrait(){
        display: none;
    }
}

.webdetail {
    .left {
        background: none;
    }
}

.main {
    overflow: hidden !important;
}


.servicepoints-container {
    position: relative;
    @include portrait(){
        position: absolute;
        right: 0px;
        width: $servicepointsPortraitWidth;
        height: 100%;
        top: 20px;
    }
}

.servicePoints {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    > div {
        margin-right: 20px;
        margin-bottom: 20px;
        @include buttonActive;
    }

    @include portrait(){
        flex-wrap: wrap;
        justify-content: flex-start;
        /*align-items: flex-start;*/
    }

    .service-point {
        position: relative;
        width: 77px;

    }

    .activeSP:after {
        content: '';
        background: $orange;
        height: 2px;
        display: block;
        position: relative;
        top: 5px;
    }
}


</style>


